<template>

  <div class="session-cloak"></div>

  <div class="session-main-wrapper">
    <div class="mx-auto session-modal col-2 p-3">
      <div class="text-center">
        <p>{{ $t('session_end_text') }}</p>
        <p>{{ $t('time_left') }}</p>
        <div class="mx-auto">

          <h3 v-if="this.time.minutes <= 0 && this.time.seconds <= 0">
            {{ '00:00' }}
          </h3>
          <h3 v-else>
            {{ '0' + this.time.minutes + ':' + (this.time.seconds < 10 ? ('0' + this.time.seconds) : this.time.seconds) }}
          </h3>
        </div>
      </div>
      <div class="session-button-wrapper text-center">
        <button class="p-2 px-5 bg-primary text-center session-button text-white border-0"
                @click="refresh()"
                :disabled="this.time.minutes <= 0 && this.time.seconds <= 0">
          {{ $t('continue') }}
        </button>
        <button class="p-2 px-5 bg-secondary session-button text-white border-0" @click="quit()">{{ $t('quit') }}</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import './sessionEnd.scss';

import axios from "axios";
import {useStore} from "vuex";
import apiService from "../../services/apiService";
import {defineComponent} from "vue";
import NameOfHelper from "../../helpers/nameOfHelper";
import type {ILoginResponse} from "@/interfaces/ILoginResponse.interface";
import {routesConst} from "../../routes.js";

export default defineComponent({
  name: "SessionEndComponent",
  components: {},
  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {
      time: {
        minutes: '',
        seconds: '',
      }
    }
  },
  created() {
    this.timer();
  },

  methods: {
    refresh() {

      axios.post(apiService.authRefresh())
          .then(response => {
            const responseData = <ILoginResponse> response.data
            this.store.commit( 'customer/SET_STATE_PROP_VALUE', [
              {prop: 'token', value: responseData .token},
              {prop: 'expire_time', value: responseData .expires_in},
              {prop: 'sessionEnd', value: false},
            ]);

          })
          .catch(err => {
            console.error(err);
          })
    },
    quit() {
      axios.post(apiService.authLogout())
          .then(response => {
            const state = this.store.state.customer;
            const nameOf = (c) => NameOfHelper.obj(c);

            this.store.commit( 'customer/SET_STATE_PROP_VALUE', [
              {prop: nameOf(() => state.token), value: null},
              {prop: nameOf(() => state.expire_time), value: null},
              {prop: nameOf(() => state.first_name), value: null},
              {prop: nameOf(() => state.last_name), value: null},
              {prop: nameOf(() => state.email), value: null},
              {prop: nameOf(() => state.mobno), value: null},
              {prop: nameOf(() => state.company_name), value: null},
              {prop: nameOf(() => state.company_number), value: null},
              {prop: nameOf(() => state.company_vat), value: null},
              {prop: nameOf(() => state.address), value: null},
              {prop: nameOf(() => state.sessionEnd), value: false},
            ]);
            // this.store.commit('customer/CLEAR_STATE');
            this.$router.push(routesConst.LOGIN);
          })
          .catch(err => {
            console.error(err);

            this.$router.push(routesConst.LOGIN);
          })

    },

    timer() {
      let timer = setInterval(() => {

        let time = new Date();
        // @ts-ignore
        let now_s = (time / 1000);
        // @ts-ignore
        let exp_time_s = (new Date(this.store.state.customer.expire_time) / 1000);
        //@ts-ignore
        this.time.minutes = Math.trunc((Math.floor(exp_time_s) - Math.floor(now_s)) / 60);
        //@ts-ignore
        this.time.seconds = ((((Math.floor(exp_time_s) - Math.floor(now_s)) / 60) % 1) * 60).toFixed(0);

        //@ts-ignore
        if (this.time.minutes <= 0 && this.time.seconds <= 0) {
          this.stopCounting(timer);

          clearInterval(timer);
        }
      }, 1000);
    },
    stopCounting(interval) {
      clearInterval(interval);
    },
  }
})
</script>
